import React from 'react';
import HomePage from './home_page/HomePage';


class App extends React.Component {
 
render(){
  return (
    <>
    <HomePage/>
    </>
 
  );
}
}

export default App;
